import React, { Suspense, useEffect } from "react";
import CustomRoutes from "./routes/Routes";
import "./App.scss";
import { HashRouter } from "react-router-dom";
import { useSelector } from "react-redux";
function App() {
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    window.document.addEventListener(
      "touchmove",
      (e) => {
        if (e.scale !== 1) {
          e.preventDefault();
        }
      },
      { passive: false }
    );
  }

  const restaurantInfo = useSelector(
    (state) => state?.homePage?.restaurantInfo
  );

  useEffect(() => {
    if (restaurantInfo?.theme == "LIGHT") {
      const root = document.documentElement;
      root?.style.setProperty("--theme-black", "#073642");
      root?.style.setProperty(
        "--appBar-background",
        "linear-gradient( 0deg, rgba(7, 54, 66, 1) 65%, rgba(7, 54, 66, 0.49343487394957986) 88%, rgba(7, 54, 66, 0) 100%)"
      );
      root?.style.setProperty(
        "--appHeader-background",
        "linear-gradient(180deg,rgba(7, 54, 66, 0.6) 0%,rgba(7, 54, 66, 0) 100%)"
      );
      root?.style.setProperty("--modal-background", "rgba(7, 54, 66, 0.75)");
      root?.style.setProperty("--theme-darkGray", "#93a1a1");
      root?.style.setProperty("--theme-white", "#fdf6e3");

      // root?.style.setProperty("--theme-black", "#000000");
      // root?.style.setProperty("--active-color", "#5b5b5b");
      // root?.style.setProperty("--theme-grey", "#464646");
      // root?.style.setProperty("--theme-darkGray", "#c8b794");
      // root?.style.setProperty("--theme-darkGray2", "#d9d9d9");
    }
  }, [restaurantInfo]);

  return (
    <HashRouter>
      <Suspense
      // fallback={<DotSpinLoader />}
      >
        <CustomRoutes />
      </Suspense>
    </HashRouter>
  );
}

export default App;
